import React from 'react';
import {Button} from "@mui/material";

const OptionComponent = (props) => {
    return (
         <Button {...props} variant="text" style={styles.button} />
    );
};

const styles = {
    button: {
        margin: '10px'
    }
}

export {OptionComponent};
